import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ApiCacheService } from '@shared/services/cache-service/api-cache.service';
import { SignalsService } from '@shared/services/signals/signals.service';
import { AppService } from 'app/app.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-loading-modal',
    imports: [
        CommonModule,
        ProgressSpinnerModule
    ],
    templateUrl: './loading-modal.component.html',
    styleUrl: './loading-modal.component.scss'
})
export class LoadingModalComponent {

  constructor(
    private cacheService: ApiCacheService,
    private signalService: SignalsService,
    public appService: AppService
  ) { }

  cancelRequest() {
    this.cacheService.ngOnDestroy();
    this.signalService.isLoading$.set(false);
  }

  progressSpinner = {
    colorScheme: {
      light: {
        root: {
          'color.1': 'var(--p-green-500)',
          'color.2': 'var(--p-yellow-500)',
          'color.3': 'var(--p-red-500)',
          'color.4': 'var(--p-primary-600)',
        }
      }
    }
  }
}
